module.exports = __webpack_public_path__ + "img/编组6.4d45297e.png";